import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSort = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 17,
	height: 13,
	viewBox: "0 0 17 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M0.5 12.4719H5.83333V10.4813H0.5V12.4719ZM0.5 0.528076V2.51871H16.5V0.528076H0.5ZM0.5 7.4953H11.1667V5.50467H0.5V7.4953Z",
		fill: "currentColor"
	})
});
export default SvgSort;
